import closestValueIndex from "./closestValueIndex";
import compareObjects from "./compareObjects";
import debounce from "./debounce";
import getTracklistId from "./getTracklistId";
import getUid from "./getUid";
import insert from "./insert";
import mapStore from "./mapStore";

export default {
  closestValueIndex,
  compareObjects,
  debounce,
  getTracklistId,
  getUid,
  insert,
  mapStore
};
